import { useEffect, useState } from 'react';
import { PostUtil } from 'src/pages/new-post-new/post-util';
import SnapchatImagePreview from './snapchat-image-preview.component';
import SnapchatVideoPreview from './snapchat-video-preview.component';

const SnapChatPublicStoryPreview = ({ data }) => {
  const [isVideo, setIsVideo] = useState(false);
  useEffect(() => {
    if (!data) return;
    if (data?.media_data?.count == 1 && data?.media_data.media_data[0].type === PostUtil.MediaType.VIDEO) {
      setIsVideo(true);
    }
  }, [data]);
  return (
    <>
      {isVideo ? (
        <SnapchatVideoPreview data={data}/>
      ) : (
        <SnapchatImagePreview data={data}/>
      )}
    </>
  );
};

export default SnapChatPublicStoryPreview;
